export default __webpack_public_path__ + "static/media/monika_permanent.72236b26.jpg";